import React from 'react';
import { Download, MoreHorizontal, Plus } from 'lucide-react';
import { INVOICES } from '../constants';

const StatusChip: React.FC<{ status: string }> = ({ status }) => {
    let colorClass = 'bg-slate-100 text-slate-600';
    if (status === 'Paid') colorClass = 'bg-emerald-100/60 text-emerald-700';
    if (status === 'Overdue') colorClass = 'bg-red-100/60 text-red-700';
    if (status === 'Sent') colorClass = 'bg-blue-100/60 text-blue-700';
    
    return (
        <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full uppercase tracking-wide ${colorClass}`}>
            {status}
        </span>
    );
}

const Finances: React.FC = () => {
  return (
    <div className="animate-fade-in space-y-6">
        <div className="flex justify-between items-center">
            <h2 className="text-lg font-medium text-slate-800">Invoices & Ledger</h2>
            <button className="flex items-center space-x-2 bg-slate-800 text-white px-4 py-2 rounded-full hover:bg-slate-700 transition-colors text-sm font-medium shadow-lg shadow-slate-200">
                <Plus size={16} />
                <span>New Invoice</span>
            </button>
        </div>

        {/* Invoice Table */}
        <div className="bg-white/60 backdrop-blur-xl rounded-2xl border border-white/40 shadow-sm overflow-hidden">
            <div className="p-4 border-b border-slate-200/50 flex justify-between items-center">
                <h3 className="text-sm font-medium text-slate-700">Recent Invoices</h3>
                <button className="text-xs text-slate-900 font-medium hover:underline">View All</button>
            </div>
            <table className="w-full text-left">
                <thead>
                    <tr className="text-xs text-slate-400 border-b border-slate-100">
                        <th className="p-4 font-normal">Invoice ID</th>
                        <th className="p-4 font-normal">Client</th>
                        <th className="p-4 font-normal">Amount</th>
                        <th className="p-4 font-normal">Due Date</th>
                        <th className="p-4 font-normal">Status</th>
                        <th className="p-4 font-normal"></th>
                    </tr>
                </thead>
                <tbody>
                    {INVOICES.map((inv) => (
                        <tr key={inv.id} className="hover:bg-white/40 transition-colors group">
                            <td className="p-4 text-sm font-medium text-slate-700">{inv.id}</td>
                            <td className="p-4 text-sm text-slate-600">{inv.client}</td>
                            <td className="p-4 text-sm font-mono text-slate-800">€{inv.amount.toLocaleString()}</td>
                            <td className="p-4 text-sm text-slate-500">{inv.dueDate}</td>
                            <td className="p-4">
                                <StatusChip status={inv.status} />
                            </td>
                            <td className="p-4 text-right flex justify-end space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                <button className="p-1 text-slate-400 hover:text-slate-600"><Download size={14}/></button>
                                <button className="p-1 text-slate-400 hover:text-slate-600"><MoreHorizontal size={14}/></button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  );
};

export default Finances;